import type confetti from "canvas-confetti";
import type { MutableRefObject } from "react";
import type { LegacyCelebrationIntensity } from "./celebration.types";
import { getCelebrationDurationMs } from "./celebrationConfetti";
import { clearWindowTimer } from "./celebrationTimers";

const LEGACY_COLORS = ["#F8FAFC", "#FACC15", "#22C55E", "#2563EB", "#111827"];

export function fireLegacyFireworks(
  fire: confetti.CreateTypes,
  intensity: LegacyCelebrationIntensity,
  perfScale: number,
  timerRef: MutableRefObject<number | null>,
) {
  clearWindowTimer(timerRef);
  const durationMs = getCelebrationDurationMs({ type: "fireworks", intensity });
  const endAt = Date.now() + durationMs;

  const tick = () => {
    const timeLeft = endAt - Date.now();
    if (timeLeft <= 0) {
      timerRef.current = null;
      return;
    }

    const lifeRatio = Math.max(0.2, timeLeft / durationMs);
    const particleCount = Math.max(8, Math.round(32 * perfScale * lifeRatio));
    fire({
      particleCount,
      angle: 60,
      spread: 56,
      startVelocity: 48,
      decay: 0.92,
      gravity: 1,
      ticks: 130,
      origin: { x: 0.18, y: 0.9 },
      colors: LEGACY_COLORS,
    });
    fire({
      particleCount,
      angle: 120,
      spread: 56,
      startVelocity: 48,
      decay: 0.92,
      gravity: 1,
      ticks: 130,
      origin: { x: 0.82, y: 0.9 },
      colors: LEGACY_COLORS,
    });

    timerRef.current = window.setTimeout(tick, 260);
  };

  tick();
}
